import React from 'react';
import * as msgpub from "msgpub";
import {TextArea, toStringArray, ButtonG, Heading} from '../Common';
import { TextInput, Grid, Box, Select, ResponsiveContext } from 'grommet';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { anyCallBackFunction, getListStr, searchText } from '../../common/AdminMqtt';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';
import { status_mapper } from '../../common/common';

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: "area1", start: [0, 0], end: [0, 0] },
        { name: "area2", start: [0, 1], end: [0, 1] },
    ],
    medium: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ],
    large: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ]
};

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: ['auto', 'auto'],
    large: ['auto', 'auto'],
}

export default function TopicLabelComponent(props: {admin?: msgpub.Admin}) {
    const {admin} = props;
    const [log, setLog] = React.useState("");
    const [topic, setTopic] = React.useState("");
    const [labelAdd, setLabelAdd] = React.useState("");
    const [labelRemove, setLabelRemove] = React.useState("");
    const [labelForTopicLabel, setLabelForTopicLabel] = React.useState("");
    const [topicList, setTopicList] = React.useState<Array<string>>([]);
    const [searchedTopicList, setSearchedTopicList] = React.useState<Array<string>>([]);
    const [labelList, setLabelList] = React.useState<Array<string>>([]);
    const [labelListStr, setLabelListStr] = React.useState<string>('');
    const [searchedLabelList, setSearchedLabelList] = React.useState<Array<string>>([]);
    const size = React.useContext(ResponsiveContext);
    const areas = AREAS[size];
    const rows = ROWS[size];
    const columns = COLUMNS[size];
    const [topicLabelList, setTopicLabelList] = React.useState<string>('');
    const disables = React.useContext(DisabelesAdminContext);

    const getTopics = () => {
	if (typeof admin !== 'undefined') {
            anyCallBackFunction(setTopicList, setSearchedTopicList, setLog, admin.setTopicInfoCallback.bind(admin), admin.getTopics.bind(admin), "getTopics");
	}
    };

    const getLabels = () => {
	if (typeof admin !== 'undefined') {
            anyCallBackFunction(setLabelList, setSearchedLabelList, setLog, admin.setLabelInfoCallback.bind(admin), admin.getLabels.bind(admin), "getLabels");
	}
    };

    const getTopicLabels = () => {
	if (typeof admin !== 'undefined') {
            admin.setTopicLabelInfoCallback((topicLabels: msgpub.AppTopicLabel[]) => {
                setTopicLabelList(toStringArray(topicLabels).join('\n'));
            });
	}

        admin?.getTopicLabels({
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[getTopicLabels func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const onChangeForLabelAdd = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLabelAdd(event.target.value);
    }

    const addLabel = () => {
        admin?.addLabel({
            label: labelAdd,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[addLabel func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const addTopicLabel = () => {
        const appTopic = topic.split(":");

        if (appTopic.length === 1) {
            admin?.addTopicLabel({
                label: labelForTopicLabel,
                topic: topic,
                callback: (status) => {
                    setLog((prevLog: string) => (prevLog + "[addTopicLabel func]status: " + status_mapper(status) + "\n"));
                }
            });
        } else if (appTopic.length === 2) {
            admin?.addExtTopicLabel({
                label: labelForTopicLabel,
                at: {topic: appTopic[1], app: appTopic[0]},
                callback: (status) => {
                    setLog((prevLog: string) => (prevLog + "[addExtTopicLabel func]status: " + status_mapper(status) + "\n"));
                }
            });
        }
    }

    const removeLabel = () => {
        admin?.removeLabel({
            label: labelRemove,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[removeLabel func]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const removeTopicLabel = () => {
        const appTopic = topic.split(":");

        if (appTopic.length === 1) {
            admin?.removeTopicLabel({
                label: labelForTopicLabel,
                topic: topic,
                callback: (status) => {
                    setLog((prevLog: string) => (prevLog + "[removeTopic func]status: " + status_mapper(status) + "\n"));
                }
            });
        } else if (appTopic.length === 2) {
            admin?.removeExtTopicLabel({
                label: labelForTopicLabel,
                at: { topic: appTopic[1], app: appTopic[0]},
                callback: (status) => {
                    setLog((prevLog: string) => (prevLog + "[removeExtTopicLabel func]status: " + status_mapper(status) + "\n"));
                }
            });
        }
    }

    const getLabelsStr = () => {
        getListStr(setLabelListStr, setLog, admin?.setLabelInfoCallback.bind(admin), admin?.getLabels.bind(admin), "getTopics");
    }

    return (
        <div>
            <Grid
                rows={rows}
                columns={columns}
                gap="xsmall"
                areas={areas}
            >
                <Box gridArea="area1">
                    <Box {...HeaderStyleForGrommet}>
                        <Heading title="label control"/>
                    </Box>
                    <Box {...MainStyleForGrommet}>
                        <form>
                            <TextInput placeholder="new label" value={labelAdd} onChange={onChangeForLabelAdd} disabled={disables.others}/>
                            <ButtonG name="add" callback={addLabel} disabled={disables.others}/>
                        </form>
                    </Box>
                    <Box {...MainStyleForGrommet}>
                        <form>
                            <Select
                                placeholder="select label"
                                value={labelRemove}
                                onSearch={input => {searchText(input, labelList, setSearchedLabelList)}}
                                onChange={(event) => {
                                    setLabelRemove(event.value);
                                }}
                                onOpen={getLabels}
                                options={searchedLabelList}
                                disabled={disables.others}
                            />
                            <ButtonG name="delete" callback={removeLabel} disabled={disables.others}/>
                        </form>
                    </Box>
                </Box>
                <Box gridArea="area2">
                    <Box {...HeaderStyleForGrommet}>
                        <Heading title="topic-label mapping"/>
                    </Box>
                    <Box {...MainStyleForGrommet}>
                        <form>
                            <Select
                                placeholder="select topic"
                                value={topic}
                                onSearch={input => {searchText(input, topicList, setSearchedTopicList)}}
                                onChange={(event) => {
                                    setTopic(event.target.value);
                                }}
                                onOpen={getTopics}
                                options={searchedTopicList}
                                disabled={disables.others}
                            />
                            <Select
                                placeholder="select label"
                                value={labelForTopicLabel}
                                onSearch={input => {searchText(input, labelList, setSearchedLabelList)}}
                                onChange={(event) => {
                                    setLabelForTopicLabel(event.value);
                                }}
                                onOpen={getLabels}
                                options={searchedLabelList}
                                disabled={disables.others}
                            />
                            <ButtonG name="add" callback={addTopicLabel} disabled={disables.others} />
                            <ButtonG name="delete" callback={removeTopicLabel} disabled={disables.others} />
                        </form>
                    </Box>
                </Box>
            </Grid>
            <TextArea texts={labelListStr} name={"label list"} disabled={disables.others} id="label-list" onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLabelListStr(e.target.value)}}/>
            <ButtonG name="get labels" callback={getLabelsStr} disabled={disables.others}/>
            <TextArea texts={topicLabelList} name={"topic-label"} disabled={disables.others} id="topic-label-list" onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setTopicLabelList(e.target.value)}}/>
            <ButtonG name="get topic-label mapping" callback={getTopicLabels} disabled={disables.others} />
            <TextArea texts={log} name={"log"} disabled={disables.others} id={"topic-label-log"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
        </div>
    );
}
